// removed by extract-text-webpack-plugin
module.exports = {"root":"src-components-BlockChartImage----index-module---root---11_CK","insight":"src-components-BlockChartImage----index-module---insight---2gR2c","title":"src-components-BlockChartImage----index-module---title---VDEGL","image":"src-components-BlockChartImage----index-module---image---29xEV"};


//////////////////
// WEBPACK FOOTER
// ./src/components/BlockChartImage/index.module.css
// module id = 596
// module chunks = 168707334958949